const SearchBar = ({ searchQuery, setSearchQuery }) => (
  <div className="relative w-full">
    <div className="absolute inset-y-0 left-0 pl-6 flex items-center pointer-events-none">
      <svg className="h-6 w-6 text-slate-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
      </svg>
    </div>
    <input
      type="text"
      placeholder="¿Qué estás buscando hoy?"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      className="block w-full pl-14 pr-6 py-5 rounded-xl border-none leading-5 bg-transparent placeholder-slate-400 focus:outline-none focus:ring-0 text-base md:text-xl text-slate-800 transition-all duration-300"
    />
  </div>
);
export default SearchBar;